import { Component } from 'vue';

import { Filter, FilterGroup } from '@/common/models/query-params';
import i18n from '@/vueI18n';

export interface IOption {
  id?: number | string;

  value?: string;

  name: string;

  options?: Array<Option>;

  selectedOptions?: Array<Option>;

  validatorName?: string;

  placeholder?: string;

  originalOptions?: Array<Option>;

  isLoading?: boolean;

  allowedWithFees?: boolean;

  textValue?: string | null;

  icon?: Component | null;

  sort?: number;

  displayField?: string;

  filters?: Filter[] | FilterGroup[];
}

export class Option implements IOption {
  id?: number | string;

  value: string;

  name: string;

  options?: Array<Option>;

  selectedOptions?: Array<Option>;

  validatorName?: string;

  placeholder?: string;

  originalOptions?: Array<Option>;

  isLoading?: boolean;

  allowedWithFees?: boolean;

  textValue?: string | null;

  icon?: Component | null;

  sort?: number;

  displayField?: string;

  filters?: Filter[] | FilterGroup[];

  constructor(
    id: number | string,
    name = '',
    value = '',
    options: Option[] = [],
    selectedOptions: Option[] = [],
    validatorName = '',
    placeholder: string = i18n.global.t('messages.startTypingToFilter'),
    originalOptions: Option[] = [],
    isLoading = false,
    allowedWithFees = true,
    textValue: string | null = null,
    sort: number = 0,
    displayField = null,
    filters: Filter[] | FilterGroup[] = [],
  ) {
    this.id = id;
    this.value = value;
    this.name = name;
    this.options = options;
    this.selectedOptions = selectedOptions;
    this.validatorName = validatorName;
    this.placeholder = placeholder;
    this.originalOptions = originalOptions;
    this.isLoading = isLoading;
    this.allowedWithFees = allowedWithFees;
    this.textValue = textValue;
    this.sort = sort;
    this.displayField = displayField;
    this.filters = filters;
  }

  static fromObject(obj: IOption, instance: Option = new Option(obj.id)) {
    Object.keys(obj).forEach((key) => {
      instance[key] = obj[key];
    });
    return instance;
  }
}

export default Option;
